import styled, { css } from 'styled-components';
export const ChipBase = styled.span.attrs({
    className: 'chip',
}) `
  display: inline-flex;
  align-items: center;
  box-sizing: border-box;
  flex-shrink: 0;

  padding: 6px 14px;
  border-radius: 999rem;
  border: 2px solid var(--color-surface-border);
  background-color: var(--color-background);

  &::-moz-focus-inner {
    border: 0;
  }

  &:focus-within {
    outline: none;
    outline: var(--outline);
    outline-offset: 4px;
  }

  & > i {
    font-size: 16px;
    line-height: 16px;
  }

  ${({ checked, type }) => {
    if (checked) {
        if (type === 'choice') {
            return css `
          color: var(--color-on-selection);
          background: var(--color-selection);
          border: 2px solid var(--color-selection);

          &:hover {
            background: var(--color-selection-hover);
          }

          &:active {
            background: var(--color-selection);
          }
        `;
        }
        return css `
        color: var(--color-on-selection);
        background: var(--color-selection);
        border: 2px solid var(--color-selection);

        &:hover {
          background: var(--color-selection-hover);
        }

        &:active {
          background: var(--color-selection);
        }
      `;
    }
    return css ``;
}}

  ${({ disabled }) => disabled &&
    css `
      color: var(--color-disabled);
      background: var(--color-on-primary);
      padding: 7px 15px;
      border: 1px solid var(--color-disabled-variant);
      cursor: not-allowed;

      &:hover {
        border: 1px solid var(--color-disabled-variant);
      }
    `}
`;
export const Input = styled.input `
  position: absolute;
  clip: rect(1px, 1px, 1px, 1px);
  height: 1px;
  width: 1px;
  opacity: 0;
  overflow: hidden;
`;
export const ChipGroupBase = styled.div `
  display: flex;
  gap: 8px;

  ${({ variant }) => variant === 'stack' &&
    css `
      flex-wrap: wrap;
    `}

  ${({ variant }) => variant === 'scroll' &&
    css `
      scrollbar-width: none;
      overflow-y: visible;
    `}
`;
export const Label = styled.label `
  cursor: pointer;
  color: var(--color-on-surface);
  font-family: 'Open Sans', sans-serif;
  line-height: 16px;
  user-select: none;
  flex-shrink: 0;

  /* Must display as block to have the top and bottom padding applied properly. */
  display: block;

  transition-property: border, background-color, color;
  transition-duration: 0.1s;

  &:hover ${ChipBase} {
    border: 2px solid var(--color-selection);
  }

  & > input:focus + span {
    outline: var(--outline);
    outline-offset: 4px;
  }

  & > input:focus:not(:focus-visible) + span {
    outline: 0;
  }

  & > input:focus-visible + span {
    outline: var(--outline);
    outline-offset: 4px;
  }
`;
